import axios from 'axios'
import router from './router'
import store from '../stores/store'
import qs from 'qs'
import { consumePendingRecaptcha, actionForUrl, execute as executeRecaptcha, reset as resetRecaptcha } from './recaptcha'

let reloadingForAccountMismatch = false

function requestFulfilled(config) {
    const authHeaders = JSON.parse(window.localStorage.getItem('authHeaders'))
    if (authHeaders) {
      const accountId = store.state.account?.id
      config.headers[config.method] = accountId ? { ...authHeaders, 'account-id': accountId } : authHeaders
    }

    const recaptcha = consumePendingRecaptcha(config.url)
    if (recaptcha && recaptcha.token) {
      config.headers['X-Recaptcha-Token'] = recaptcha.token
      config.headers['X-Recaptcha-Action'] = recaptcha.action
    }

    config.paramsSerializer = params => qs.stringify(params, {
      arrayFormat: 'brackets',
      encode: false
    })

    return config
}

function requestRejected(error) {
  return Promise.reject(error)
}

function responseFulfilled(response) {
    setHeader(response)
    return response.data
}

// O bloqueio pode ser transitório (token gerado por um grecaptcha velho, ou
// corrida entre requests). Recicla o cliente e repete uma única vez antes de
// mostrar erro para o usuário.
function retryWithFreshRecaptcha(error) {
  const config = error.config
  const action = actionForUrl(config.url)
  if (!action) return Promise.reject(error.response.data)

  config.__recaptchaRetried = true
  setHeader(error.response)
  delete config.headers['X-Recaptcha-Token']
  delete config.headers['X-Recaptcha-Action']

  resetRecaptcha()

  return executeRecaptcha(action)
    .catch(() => Promise.reject(error.response.data))
    .then(() => axios.request(config))
}

function responseRejected(error) {
    if (axios.isCancel(error)) {
      return Promise.reject(error)
    } else if (error.message === 'Network Error') {
      return Promise.reject({ errors: 'Ops! Parece que a aplicação não está respondendo.' })
    } else if (error.response?.status === 403 &&
               error.response?.data?.code === 'recaptcha_failed' &&
               !error.config.__recaptchaRetried) {
      return retryWithFreshRecaptcha(error)
    } else if (error.response?.status === 409 && error.response?.data?.code === 'account_mismatch') {
      setHeader(error.response)
      const lastReload = Number(sessionStorage.getItem('account_mismatch_reload_at') || 0)
      if (Date.now() - lastReload > 10000 && !reloadingForAccountMismatch) {
        reloadingForAccountMismatch = true
        sessionStorage.setItem('account_mismatch_reload_at', String(Date.now()))
        localStorage.removeItem('userAuthenticated')
        window.location.reload()
      }
      if (reloadingForAccountMismatch) return new Promise(() => {})
    } else if (error.response.status === 401) {
      clearAuthHeader()
      const currentPath = router.currentRoute.path
      if (currentPath !== '/login') {
        router.push('/login').catch(e => { window.console.log('redirect', e) })
      }
    } else if (error.response.status === 429) {
      setHeader(error.response)
      localStorage.removeItem('startPath')
      return Promise.reject({ errors: 'Muitas requisições simultâneas. Por favor aguarde um momento.' })
    } else {
      setHeader(error.response)
    }

    if (!error?.response)
        console.error(error)

    return Promise.reject(error?.response?.data || 'Ops! Ocorreu um erro. Atualize a página e tente novamente.')
  }

function setHeader(response) {
  if (!response.headers['access-token'])
    return

  const authHeaders = {
    'access-token': response.headers['access-token'],
    'client': response.headers['client'],
    'expiry': response.headers['expiry'],
    'token-type': response.headers['token-type'],
    'uid': response.headers['uid']
  }
  localStorage.setItem('authHeaders', JSON.stringify(authHeaders));
}

function clearAuthHeader() {
  store.commit('setUser', null)
  localStorage.removeItem('authHeaders')
}

axios.interceptors.request.use(requestFulfilled, requestRejected)
axios.interceptors.response.use(responseFulfilled, responseRejected)
axios.defaults.baseURL = process.env.VUE_APP_ROOT_API_URL

axios.v3 = axios.create({ baseURL: process.env.VUE_APP_ROOT_API_URL.replace('/api/v2', '/v3')})
axios.v3.interceptors.request.use(requestFulfilled, requestRejected)
axios.v3.interceptors.response.use(responseFulfilled, responseRejected)

export default axios
